import type { JSX, ReactNode } from "react";

/** Standard page header row: title on the left, actions (buttons/search) on
 *  the right. Wraps on narrow screens so mobile never overflows. Every page
 *  starts with one of these. */
export function PageHeader({
  title,
  children,
}: {
  title: string;
  children?: ReactNode;
}): JSX.Element {
  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
      <h2 className="text-2xl font-semibold tracking-tight">{title}</h2>
      {children ? <div className="flex flex-wrap items-center gap-2">{children}</div> : null}
    </div>
  );
}
